import React, { ReactElement } from 'react';
import { currencyWithCents } from '~/lib/format';
import { useEventDispatch } from '~/lib/events';

export default React.memo(function PlusUpsell({
  selectedPlanPrice,
}: Readonly<{
  selectedPlanPrice: number;
}>): ReactElement {
  const dispatchEvent = useEventDispatch();

  return (
    <button
      className="mx-auto my-4 w-fit cursor-pointer rounded bg-[#FFEEEA] px-2 py-1 text-sm font-semibold text-ready-red md:mx-0 md:mt-0 md:mb-3"
      onClick={() => dispatchEvent('pdp:showPlusShelf')}
    >
      <span>
        Save an additional {currencyWithCents(selectedPlanPrice / 10)} with Plus
      </span>
    </button>
  );
});
